import { MILLISECONDS_IN_HOUR } from "../unit-utils/time";

export function addHours(oldDate: Date, hoursToAdd: number): Date {
    return new Date(oldDate.getTime() + hoursToAdd * MILLISECONDS_IN_HOUR);
}
